<p>static-pages works!</p>
